window.addEventListener('DOMContentLoaded', (e) => {

    // update aria states on focus (keyboard) and mouse over events

    document.querySelectorAll('.menu-item-has-children').forEach(element => {
        let a = element.querySelector('a');
        if (a.hasAttribute('aria-haspopup')) {
            element.addEventListener('focusin', (event) => {
                event.currentTarget.querySelector('a').setAttribute('aria-expanded', true);
            }, true);
            element.addEventListener('mouseover', (event) => {
                event.currentTarget.querySelector('a').setAttribute('aria-expanded', true);
            }, true);
            element.addEventListener('focusout', (event) => {
                event.currentTarget.querySelector('a').setAttribute('aria-expanded', false);
            }, true);
            element.addEventListener('mouseout', (event) => {
                event.currentTarget.querySelector('a').setAttribute('aria-expanded', false);
            }, true);
        }
    });

    // aria-label="Opens a new tab"
    document.querySelectorAll('a[target="_blank"]').forEach(element => {
        if (!element.hasAttribute('aria-label')) {
            element.setAttribute('aria-label', 'Opens a new tab');
        }
    });

    // aria-label="Embedded video"
    document.querySelectorAll('.wp-block-embed.is-type-video').forEach(element => {
        if (!element.hasAttribute('aria-label')) {
            element.setAttribute('aria-label', 'Embedded video');
        }
    });

    // aria-required="true"
    document.querySelectorAll('[data-reqmsg]').forEach(element => {
        if (!element.hasAttribute('aria-required')) {
            element.setAttribute('aria-required', 'true');
        }
    });

    // role="heading"
    document.querySelectorAll('.font-display, .has-lg-font-size, .has-xl-font-size, .has-2xl-font-size, .has-3xl-font-size, .has-4xl-font-size, .has-5xl-font-size, .has-6xl-font-size, .has-7xl-font-size, .has-8xl-font-size, .has-9xl-font-size').forEach(element => {
        element.setAttribute('role', 'heading');
    });

    // role="none"
    document.querySelectorAll('.wp-block-image').forEach(element => {
        element.setAttribute('role', 'none');
    });

    // role="button"
    document.querySelectorAll('.wp-block-button__link, .glink').forEach(element => {
        element.setAttribute('role', 'button');
    });

});

window.addEventListener('body-change', function(e) {
    // role="presentation"
    document.querySelectorAll('.goog-te-spinner-pos').forEach(element => {
        element.setAttribute('role', 'presentation');
    });
});